<ng-container *ngIf="isOpen()">
  <div class="pf-overlay" (click)="close()"></div>

  <div class="pf-panel" role="dialog" aria-label="Edit Profile">
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()" (keydown.enter)="$event.preventDefault()">
      <header class="pf-head">
        <div class="pf-head-ic">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
        </div>
        <div class="pf-head-txt">
          <h2>Edit Profile</h2>
          <p class="pf-sub">Update your photo and personal details</p>
        </div>
        <button type="button" class="pf-close" (click)="close()" title="Close" aria-label="Close">✕</button>
      </header>

      <div class="pf-body">
        <div class="pf-avatar-row">
          <div class="pf-avatar-wrap">
            <img *ngIf="preview" [src]="preview" alt="Profile picture"/>
            <!-- No photo (or one that 404s) falls back to the user's initials, the same
                 default the account and contact identity headers use. -->
            <img *ngIf="!preview && avatarUrl && !photoFailed" [src]="avatarUrl" alt="Profile picture"
                 (error)="photoFailed = true"/>
            <span *ngIf="!preview && (!avatarUrl || photoFailed)" class="pf-avatar-initials"
                  [attr.aria-label]="fullName">{{ initials }}</span>
            <!-- Upload and remove are mutually exclusive: while a stored photo is on screen
                 only the X is offered, so the camera badge never overlaps it. Uploading is
                 available again once the photo has been removed (initials showing), and
                 stays available while a freshly picked file is previewed so it can be
                 swapped before saving. -->
            <label *ngIf="!hasPhoto" class="pf-camera" title="Upload photo">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                   stroke-linecap="round" stroke-linejoin="round">
                <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
                <circle cx="12" cy="13" r="4"/>
              </svg>
              <input type="file" accept="image/png, image/jpeg" (change)="handleFileInput($event)"/>
            </label>
            <button *ngIf="hasPhoto" type="button" class="pf-remove" title="Remove profile image"
                    aria-label="Remove profile image" [disabled]="removing" (click)="removePhoto()">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"
                   stroke-linecap="round">
                <path d="M18 6L6 18M6 6l12 12"/>
              </svg>
            </button>
          </div>
          <!-- Same rule as the camera badge: no upload button or format hint while a stored
               photo is on screen — the X is the only action until it is removed. -->
          <div class="pf-avatar-meta" *ngIf="!hasPhoto">
            <label class="pf-upload">
              Upload new photo
              <input type="file" accept="image/png, image/jpeg" (change)="handleFileInput($event)"/>
            </label>
            <div class="pf-hint">JPG or PNG, at least 140 × 140 px.</div>
          </div>
        </div>

        <div class="pf-grid">
          <div class="pf-field">
            <label for="firstName">First Name</label>
            <input id="firstName" type="text" formControlName="first_name" placeholder="First Name"
                   [class.pf-invalid]="(isLoading || uf.first_name.errors?.apiError) && uf.first_name.invalid"/>
            <div class="pf-err" *ngIf="(isLoading || uf.first_name.errors?.apiError) && uf.first_name.invalid">
              <span *ngIf="uf.first_name.errors?.required">Enter first name.</span>
              <span *ngIf="uf.first_name.errors?.apiError">{{ uf.first_name.errors?.apiError }}</span>
            </div>
          </div>

          <div class="pf-field">
            <label for="lastName">Last Name</label>
            <input id="lastName" type="text" formControlName="last_name" placeholder="Last Name"
                   [class.pf-invalid]="(isLoading || uf.last_name.errors?.apiError) && uf.last_name.invalid"/>
            <div class="pf-err" *ngIf="(isLoading || uf.last_name.errors?.apiError) && uf.last_name.invalid">
              <span *ngIf="uf.last_name.errors?.required">Enter last name.</span>
              <span *ngIf="uf.last_name.errors?.apiError">{{ uf.last_name.errors?.apiError }}</span>
            </div>
          </div>

          <div class="pf-field pf-full">
            <label for="email">Email</label>
            <input id="email" type="email" formControlName="email" placeholder="Email"
                   [class.pf-invalid]="(isLoading || uf.email.errors?.apiError) && uf.email.invalid"/>
            <div class="pf-err" *ngIf="(isLoading || uf.email.errors?.apiError) && uf.email.invalid">
              <span *ngIf="uf.email.errors?.required">Enter email address.</span>
              <span *ngIf="!uf.email.errors?.required && uf.email.errors?.email">Enter a valid email address.</span>
              <span *ngIf="uf.email.errors?.apiError">{{ uf.email.errors?.apiError }}</span>
            </div>
          </div>
        </div>
      </div>

      <footer class="pf-foot">
        <button type="button" class="btn-secondary btn-sm" (click)="close()">Cancel</button>
        <button type="submit" class="btn-primary btn-sm" [disabled]="submitted">
          {{ submitted ? 'Saving…' : 'Save Changes' }}
        </button>
      </footer>
    </form>
  </div>
</ng-container>
